import Button from '@atoms/Button'

import { scopedTranslation } from '@utils/I18n'

import { useShiftsStore } from './stores/useShiftsStore'

import { isPublishable } from '../shifts/publishState'
import type { ShiftWithSlots } from '../shifts/types'

const t = scopedTranslation('roster_board')

type BulkActionsBarProps = {
  shifts: ShiftWithSlots[]
}

export function BulkActionsBar({ shifts }: BulkActionsBarProps) {
  const selectedShiftIds = useShiftsStore((state) => state.selectedShiftIds)
  const openPublish = useShiftsStore((state) => state.openPublish)
  const openBulkDelete = useShiftsStore((state) => state.openBulkDelete)
  const clearSelection = useShiftsStore((state) => state.clearSelection)

  if (selectedShiftIds.size === 0) return null

  const publishableIds = shifts.filter((shift) => selectedShiftIds.has(shift.id) && isPublishable(shift)).map((shift) => shift.id)

  return (
    <div role="region" aria-label={t('bulk.region_label')} className="tw:flex tw:w-full tw:flex-wrap tw:items-center tw:gap-3">
      <span className="tw:text-sm tw:font-semibold tw:text-primary-800">
        {t('bulk.selected', { count: selectedShiftIds.size })}
      </span>
      <div className="tw:ml-auto tw:flex tw:flex-wrap tw:items-center tw:gap-2">
        <Button
          rank="secondary"
          size="sm"
          leadingIcon="check"
          disabled={publishableIds.length === 0}
          onClick={() => openPublish(publishableIds)}
        >
          {t('bulk.publish')}
        </Button>
        <Button
          rank="secondary"
          color="danger"
          size="sm"
          leadingIcon="trash-01"
          onClick={() => openBulkDelete([...selectedShiftIds])}
        >
          {t('bulk.delete')}
        </Button>
        <button
          type="button"
          onClick={clearSelection}
          className="tw:text-sm tw:font-medium tw:text-primary-700 tw:hover:underline"
        >
          {t('bulk.clear')}
        </button>
      </div>
    </div>
  )
}
